// utils/fetchWithCache.js
const cache = new Map();
const inFlight = new Map();
const TTL = 15 * 60 * 1000; // cache 15 minutes
const timestamps = new Map();

export const fetchWithCache = async (key, fetchFn) => {
  const now = Date.now();

  // Return from cache if still fresh
  if (cache.has(key) && now - timestamps.get(key) < TTL) {
    return cache.get(key);
  }

  // Return in-flight request if exists
  if (inFlight.has(key)) {
    return inFlight.get(key);
  }

  // Make a new fetch call
  const promise = fetchFn()
    .then((data) => {
      cache.set(key, data);
      timestamps.set(key, now);
      inFlight.delete(key);
      return data;
    })
    .catch((err) => {
      inFlight.delete(key);
      throw err;
    });

  inFlight.set(key, promise);
  return promise;
};